import React from "react";
import MuiGrid from "@mui/material/Grid";
import clsx from "clsx";
import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { GridProps } from "./Grid.types";
import { createVerticalSpacing } from "./GridStyles";

export const useStyles = makeStyles((theme) => ({
  root: (props: GridProps) => ({
    flex: props.flex,
    minWidth: props.flex ? 1 : 0,
  }),
  ...createVerticalSpacing(theme),
}));

function Grid(props: GridProps) {
  const { className: classNameProp, verticalSpacing, flex, ...other } = props;

  const classes = useStyles(props) as any;

  const className = clsx(classNameProp, classes.root, {
    [classes[`vspacing-xs-${verticalSpacing}`]]: verticalSpacing !== undefined,
  });

  return <MuiGrid className={className} {...other} />;
}

export default Grid;
